import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import Inputbox from "../../Components/Inputbox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  AddResourceTypes,
  DeleteResource,
  DeleteResType,
  EditResource,
  GetResource,
  GetRespo,
  PostResource,
} from "../../../api/helper";
import { useSelector } from "react-redux";
import { ShowToast } from "../../../helpers/ToastService";
import DeleteModal from "../Components/DeleteModal";

const validationSchema = Yup.object().shape({
  resourceType: Yup.string().required("Resource Type is required"),
  name: Yup.string()
    .required("Resource Name is required")
    .min(2, "Name must be at least 2 characters"),
  color: Yup.string().required("Color is required"),
  description: Yup.string().required("Definition is required"),
  sortOrder: Yup.number()
    .typeError("Sort Order must be a number")
    .required("Sort Order is required")
    .min(0, "Must be 0 or greater"),
});

const AppointmentResources = () => {
  const [showModal, setShowModal] = useState(false);
  const [typesmodal, settypesmodal] = useState(false);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const [resourceType, setResourceType] = useState("");
  const [error, setError] = useState("");
  const openModal = () => setShowModal(true);
  const closeModal = () => {
    reset({
      resourceType: "",
      name: "",
      color: "#000000",
      description: "",
      sortOrder: 0,
    });
    setShowModal(false);
    setIsEditMode(false);
    setEditId(null);
  };

  const [resourcedata, setresourcedata] = useState([]);
  const [data, setdata] = useState([]);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    data.agencyId = profiledata?._id;

    try {
      let respo;
      if (isEditMode && editId) {
        respo = await EditResource(data, editId);
      } else {
        respo = await PostResource(data);
      }

      ShowToast(respo?.data?.message);
      FetchResource();
      reset();
      setIsEditMode(false);
      setEditId(null);
      closeModal();
    } catch (error) {
      console.log(error);
    }
  };

  const FetchResource = async () => {
    try {
      const respo = await GetResource(profiledata?._id);
      setdata(respo?.data?.data?.results);
    } catch (error) {
      console.log(error);
    }
  };
  const addResourceTypes = async () => {
    if (!resourceType) {
      setError("Please enter a valid resource type.");
      return;
    }

    const data = {
      resourceType: resourceType,
      agencyId: profiledata?._id,
    };
    try {
      const respo = await AddResourceTypes(data);
      ShowToast(respo?.data?.message);
      settypesmodal(false);
      FetchResTypes();
    } catch (error) {
      console.log(error);
    }
  };
  const FetchResTypes = async () => {
    try {
      const respo = await GetRespo(profiledata?._id);

      setresourcedata(respo?.data?.data?.results);
    } catch (error) {
      console.log(error);
    }
  };
  const RemoveResType = async (id) => {
    try {
      const respo = await DeleteResType(id);
      ShowToast(respo?.data?.message);

      FetchResTypes();
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    FetchResTypes();
    FetchResource();
  }, []);

  const handleDelete = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
    try {
      const respo = await DeleteResource(deleteId);
      ShowToast(respo?.data?.message);
      FetchResource();
    } catch (error) {
      console.error("Delete operation failed:", error);
      ShowToast("An error occurred while deleting the address.");
    }
  };

  const handleEdit = (row) => {
    setIsEditMode(true);
    setEditId(row._id);
    setShowModal(true);

    reset({
      resourceType: row?.resourceType?._id || "",
      name: row?.name || "",
      color: row?.color || "#000000",
      description: row?.description || "",
      sortOrder: row?.sortOrder || 0,
    });
  };

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        justifyItems: "center",
        marginBottom: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <h1>Appointment Resources</h1>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div className="add-button_user" onClick={openModal}>
            + New Resource
          </div>
          <div
            className="add-button_user"
            onClick={() => {
              settypesmodal(true);
            }}
            style={{ marginLeft: 10 }}
          >
            Manage Types
          </div>
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th>Color</th>
            <th>Definition</th>
            <th>Sort #</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="11" style={{ textAlign: "center", padding: "20px" }}>
                No data found.
              </td>
            </tr>
          ) : (
            [...data]
              .sort((a, b) => a.sortOrder - b.sortOrder)
              .map((row, index) => (
                <tr key={index} style={tableRowStyle}>
                  <td style={tableCellStyle}>
                    {row?.resourceType?.resourceType}
                  </td>
                  <td style={tableCellStyletwo}>{row?.name}</td>
                  <td style={tableCellStyletwo}>
                    <div
                      className="Reason_Color"
                      style={{
                        backgroundColor: row.color,
                        borderRadius: 6,
                      }}
                    />
                  </td>
                  <td style={tableCellStyletwo}>{row?.description}</td>
                  <td style={tableCellStyletwo}>{row?.sortOrder}</td>
                  <td style={tableCellStyle}>
                    <button
                      className="action_icon_btn"
                      title="Edit"
                      onClick={() => handleEdit(row)}
                    >
                      <i className="fas fa-edit" style={{ color: "black" }} />
                    </button>
                    <button
                      className="action_icon_btn"
                      title="Delete"
                      onClick={() => handleDelete(row._id)}
                    >
                      <i
                        className="fas fa-trash-alt"
                        style={{ color: "black" }}
                      />
                    </button>
                  </td>
                </tr>
              ))
          )}
        </tbody>
      </table>
      <Modal
        open={showModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
      >
        <Box sx={modalStyle}>
          <h2 id="statusModalTitle">Add Resource</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group_CalendarView">
              <label htmlFor="client-select">Resource Type</label>
              <select id="client-select" {...register("resourceType")}>
                <option value="">-- Select --</option>
                {resourcedata.map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.resourceType}
                  </option>
                ))}
              </select>
              {errors.resourceType && (
                <p className="error">{errors.resourceType.message}</p>
              )}
            </div>
            <div className="form-group_AppointmentVisitStatus">
              <label htmlFor="name">Resource Name</label>
              <input
                type="text"
                id="name"
                {...register("name")}
                placeholder="e.g. Canceled, No-Show, Scheduled"
              />
              {errors.name && <p className="error">{errors.name.message}</p>}
            </div>

            <div className="form-group_AppointmentVisitStatus">
              <label>Color</label>
              <input type="color" {...register("color")} />
            </div>
            {errors.color && <p className="error">{errors.color.message}</p>}
            <div className="form-group_AppointmentVisitStatus">
              <label>Definition</label>
              <input
                type="text"
                {...register("description")}
                placeholder="Describe what this status means"
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.description?.message}
              </p>
            </div>

            <div className="form-group_AppointmentVisitStatus">
              <label>Sort Order</label>
              <input
                type="number"
                placeholder="0"
                min={0}
                {...register("sortOrder")}
              />
              {errors.sortOrder && (
                <p className="error">{errors.sortOrder.message}</p>
              )}
            </div>

            <div className="form-actions_VisitStatus">
              <button
                type="button"
                onClick={closeModal}
                className="btn_VisitStatus btn_VisitStatus-secondary"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn_VisitStatus btn_VisitStatus-primary"
                style={{ marginLeft: 10 }}
              >
                Save
              </button>
            </div>
          </form>
        </Box>
      </Modal>
      <Modal
        open={typesmodal}
        onClose={() => settypesmodal(false)}
        aria-labelledby="modal-title"
      >
        <Box sx={modalStyle}>
          <h2 id="statusModalTitle">Manage Resource Types</h2>
          <ul
            className="type-list"
            style={{ listStyle: "none", padding: 0, margin: 0 }}
          >
            {resourcedata?.map((type, index) => (
              <li
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "6px 0",
                  borderBottom: "1px solid #eee",
                }}
              >
                <span>{type?.resourceType}</span>
                <button
                  className="btn_three btn-link delete-type-btn"
                  onClick={() => RemoveResType(type?._id)}
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
          <div className="form-group_AppointmentVisitStatus">
            <input
              type="text"
              placeholder="New Type Name"
              value={resourceType}
              onChange={(e) => {
                setResourceType(e.target.value);
                if (error) setError("");
              }}
            />
            {error && <p style={{ color: "red", marginTop: 5 }}>{error}</p>}
          </div>

          <div className="form-actions_VisitStatus">
            <button
              type="button"
              onClick={() => {
                settypesmodal(false);
              }}
              className="btn_VisitStatus btn_VisitStatus-secondary"
            >
              Cancel
            </button>
            <button
              onClick={addResourceTypes}
              type="submit"
              className="btn_VisitStatus btn_VisitStatus-primary"
              style={{ marginLeft: 10 }}
            >
              Save
            </button>
          </div>
        </Box>
      </Modal>
      {confirmdeletemodal && (
        <DeleteModal
          name="Appointment Resources"
          onClose={() => setconfirmdeletemodal(false)}
          onConfirm={confirmDelete}
        />
      )}
    </div>
  );
};

export default AppointmentResources;
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 4,
  outline: "none",
};

const tableCellStyle = {
  padding: "8px",
  borderBottom: "1px solid #ddd",
  maxWidth: "200px", // Set a max width to prevent excessive stretching
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const tableCellStyletwo = {
  padding: "8px",
  borderBottom: "1px solid #ddd",
  width: "60%",
  maxWidth: "400px", // Set a max width to limit lengthy text display
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const tableRowStyle = {
  borderBottom: "1px solid #ddd",
};

const deleteButtonStyle = {
  backgroundColor: "red",
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "5px 10px",
  cursor: "pointer",
};
